import type { CellCoordinate, TableCellAdapter } from 'ui/components/HourlyDataTable/HourlyDataTable.types'
import { type ElplanCellKey, type ElplanEditorRow, type ElplanSlot, isElplanSlotUnit } from './ElplanEditor.types'

function toElplanCellKey(slot: ElplanSlot): ElplanCellKey {
  return `${slot.unit}@${slot.start}`
}

export function parseElplanCellKey(cellKey: string): ElplanSlot | null {
  const separatorIndex = cellKey.indexOf('@')
  const unit = cellKey.slice(0, separatorIndex)
  const start = cellKey.slice(separatorIndex + 1)
  if (separatorIndex < 0 || !isElplanSlotUnit(unit) || start === '') {
    return null
  }

  return { unit, start: start as ISODateTime }
}

export function getElplanRowCellKey(row: ElplanEditorRow): ElplanCellKey {
  return toElplanCellKey({ unit: row.kind, start: row.start })
}

export function createElplanEditorAdapter(rows: readonly ElplanEditorRow[]): TableCellAdapter {
  const cellKeys = rows.map(getElplanRowCellKey)
  const rowIndexByCellKey = new Map<string, number>(cellKeys.map((cellKey, rowIndex) => [cellKey, rowIndex]))

  return {
    columnCount: 1,
    rowCount: rows.length,
    getCoordinate(cellKey: string): CellCoordinate | null {
      const rowIndex = rowIndexByCellKey.get(cellKey)
      return rowIndex === undefined ? null : { rowIndex, columnIndex: 0 }
    },
    getCellKey({ rowIndex, columnIndex }: CellCoordinate): string | null {
      return columnIndex === 0 ? (cellKeys[rowIndex] ?? null) : null
    },
  }
}
